import { createFileRoute } from '@tanstack/react-router'
import { PlpsPage } from '@/features/plps'

export const Route = createFileRoute('/_authenticated/plps/')({
  component: PlpsPage,
})
